import { useQuery } from '@tanstack/react-query';

import { getContestInvitesStats } from '~/services/commissioner/commissioner-service.service.api';

export function useContestInvitesStats({
  contestId,
  channelId,
}: {
  contestId?: string;
  channelId?: string;
}) {
  // eslint-disable-next-line local-rules/require-query-stale-time
  return useQuery({
    queryKey: ['contestInvitesStats', contestId, channelId],
    queryFn: () => getContestInvitesStats(contestId, channelId),
    refetchInterval: (data) => (data?.invitesProcessing ? 2000 : false),
    enabled: !!contestId && !!channelId,
  });
}
